module.exports = __webpack_public_path__ + "static/media/expense.3d496cb9.JPG";